let state = {
  activedIndex: 0,
  applicantInfo: {
    saveed: false,
  },
  personnel: {
    saveed: false,
  },
  implementation: {
    saveed: false,
  },
  tabsIndex: 'author',
};

export default state;
